<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode, animated: false, fadeIn: true }">

    <CCard v-if="oilStore && oilHist && oilCodeMap">
      <CCardHeader>
        <BIconDropletFill/> <strong>유종별 현황</strong>
        <div class="card-header-actions d-flex align-items-center">
          <BFormSelect size="sm"
                       class="mr-2 w-auto theme-select"
                       v-model="oilDays"
                       :options="oilDaysOpts"/>
          <BFormSelect size="sm"
                       class="mr-2 w-auto theme-select"
                       v-model="oilVolUnit"
                       :options="oilVolUnitOpts"/>
          <BButton size="sm" variant="outline-info" :disabled="!isOilReady" @click="getOilWidget">
            <BIconArrowClockwise/>
          </BButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <BRow>
          <BCol md="4" v-for="ocd in oilCodes" :key="ocd">
            <WidgetOils  :oilCode="ocd"
                        :oilName="oilCodeMap[ocd]"
                        :oilColor="oilColors[ocd]"
                        :store="oilStore[ocd]"
                        :oilData="oilHist[ocd].data"
                        :labels="oilHist[ocd].label"
                        :volUnit="oilVolUnit"
            />
          </BCol>
        </BRow>
      </CCardBody>
    </CCard>

    <BRow  class="pre-scrollable mh-100" v-if="isReady">
      <BCol xl="12" v-for="area in areaCodes" :key="area.code">

        <CCard>
          <CCardHeader>
            <BButton class="ml-1 font-weight-bolder"
                     variant="outline-warning"
                     size="sm"
                     @click="gotoMonitor(area.arCode)"
            >
              <BIconBack/> {{area.name}} 지역 모니터링
            </BButton>

            <div class="card-header-actions d-flex align-items-center">
              <span class="text-muted mr-3">
                <BBadge variant="info"> {{area.name}} </BBadge>  {{area.description}}
              </span>
              <BFormSelect size="sm"
                           class="mr-2 w-auto theme-select"
                           v-model="tankVolUnit"
                           :options="tankVolUnitOpts"/>
              <BButton size="sm" variant="outline-info" v-b-tooltip.hover title="팝업 보기" @click="openAreaPopup(area.arCode)">
                <CIcon name="cil-external-link"/>
              </BButton>
            </div>
          </CCardHeader>

          <CCardBody>
          <!-- 칼럼을 고정 분할(xl=4)하지 않고 카드 폭(520~580px)만큼 차지하게 해,
               브라우저가 넓어지면 한 줄에 카드가 더 들어가도록 한다 -->
          <BRow v-if="area.tanks">
            <BCol v-for="tank in area.tanks" :key="tank.tid" v-show="tank.display"
                  style="flex: 1 1 520px; max-width: 580px; min-width: 520px">

              <CCard style="min-width:520px; max-width:580px">
                <CCardHeader>
                  <BButtonGroup size="sm" class="small">
                    <BButton variant="outline-info"
                             size="sm"
                             @click="gotoMonitor(area.arCode, tank.tid)">
                      <BIconBack/> <B>{{tank.name}}</B>
                    </BButton>
                    <BButton class="ml-1" :style="{color: '#000000', backgroundColor: oilColors[tank.oilCode]}">
                      <strong>{{oilCodeMap[tank.oilCode]}}</strong>
                    </BButton>
                    <BButton class="ml-1" :variant="tankState[tank.tid].variant">
                      <strong>{{tankState[tank.tid].text}}</strong>
                    </BButton>
                    <!-- 패킷 상태: 텍스트 대신 아이콘 배지. 상태명은 툴팁으로 보여준다 -->
                    <BBadge class="ml-1 px-2 d-inline-flex align-items-center psts-badge"
                            :variant="tankState[tank.tid].pstsVariant"
                            :class="{blink: tankState[tank.tid].psts.code!=='0000'}"
                            v-b-tooltip.hover
                            :title="tankState[tank.tid].psts.message">
                      <BIcon :icon="pstsIcon(tankState[tank.tid].psts.code)" font-scale="1.2"/>
                    </BBadge>
                  </BButtonGroup>

                  <div class="card-header-actions">
                    <WidgetEvents :ref="`evt-${tank.tid}`" class="float-right"/>
                  </div>
                </CCardHeader>

                <CCardBody>
                <BRow class="mb-1" :key="progressKey">
                  <BCol cols="7">
                    <BProgress :max="100" height="2rem" show-value>
                      <BProgressBar :value="volumes[tank.tid].tvp"
                                    :animated="tankState[tank.tid].sts!=='N'"
                                    :variant="progressVariant(volumes[tank.tid].tvp)"/>
                    </BProgress>
                  </BCol>
                  <BCol cols="5" class="text-right">
                    <BButtonGroup size="sm">
                      <BButton variant="info">
                        <strong>{{ trans(volumes[tank.tid].ovm, 'v', tankVolUnit || tank.unitOfVol ) }}</strong>
                      </BButton>
                      <BButton variant="outline-info" class="small text-nowrap">
                        {{ trans(volumes[tank.tid].real, 'v', tankVolUnit || tank.unitOfVol) }} <BBadge>{{unitSign(tankVolUnit || tank.unitOfVol)}}</BBadge>
                      </BButton>
                    </BButtonGroup>

                  </BCol>
                </BRow>

                <BRow>
                  <BCol>
                    <TankLineChart :ref='`chart-${tank.tid}`' style="min-height: 250px; max-height: 300px;"
                                   :tank="tank"
                                   :oilColor="oilColors[tank.oilCode]"
                                   :key="tankChartKey[tank.tid]"

                    />
<!--                    :tankData="tankHist[tank.tid]"-->

                  </BCol>
                </BRow>
                </CCardBody>

              </CCard>


            </BCol>
          </BRow>
          </CCardBody>

        </CCard>

      </BCol>
    </BRow>

  <!--
    <p>This view file path: src/views/dashboard</p>
    <p>
      <span class="mr-1" target="_blank">Check</span>
      <a href="https://coreui.io/vue/docs">CoreUI Vue Documentation</a>
    </p>
    -->
  </div>
</template>

<script>
import '@/common/HelperMixin';
import WidgetOils from './components/widget/WidgetOils'
import WidgetEvents from './components/widget/WidgetEvents'
import TankLineChart from './components/charts/TankLineChart'
import {
  apiCall, random, sleep, speech, trans, unitSign
} from '@/common/utils';
import {IoStsMap, PacketStsIconMap} from "@/common/constants";

export default {
  name: 'Dashboard',
  components: {
    WidgetOils,
    WidgetEvents,
    TankLineChart
  },
  computed: {

  },
  data () {
    return {
      isReady: false,
      progressKey: random(0,10000),
      widgetKey: random(20000,30000),
      isOilReady: false,
      isTankReady: false,
      oilStore: null,
      oilHist: null,
      oilCodes: [],
      oilColors: null,
      oilCodeMap: null,
      areaCodes: null,
      tanks: null,
      tankHist: [],
      eventsKey: 0,
      tankChartKey: {},
      tankState: {},
      tankStateWatch: {tid:'', code: '', message: ''},
      volumes: {},
      events: {},
      volUnit: 'g', // l <--> g
      // 유종별현황 그래프 조회 기간(일). 선택값은 localStorage 에 저장되어 유지된다
      oilDays: Number(localStorage.getItem('oilDays')) || 7,
      oilDaysOpts: [
        { value: 3, text: '3일' },
        { value: 7, text: '7일' },
        { value: 15, text: '15일' },
        { value: 30, text: '30일' },
      ],
      // 유종별현황 카드 단위 (페이지 이동 후에도 유지되도록 localStorage 에 저장)
      oilVolUnit: localStorage.getItem('oilVolUnit') || 'k',
      oilVolUnitOpts: [
        { value: 'k', text: 'K리터(kL)' },
        { value: 'l', text: '리터(L)' },
        { value: 'g', text: '갤런(gal)' },
        { value: 'd', text: '드럼(D)' },
      ],
      // 지역별 모니터링 카드 단위. ''(탱크단위)면 탱크별 설정(unitOfVol)을 따른다
      tankVolUnit: localStorage.getItem('tankVolUnit') || '',
      tankVolUnitOpts: [
        { value: '', text: '탱크단위' },
        { value: 'k', text: 'K리터(kL)' },
        { value: 'l', text: '리터(L)' },
        { value: 'g', text: '갤런(gal)' },
        { value: 'd', text: '드럼(D)' },
      ],
      lenUnit: 'i', // mm <--> i
      tmpUnit: 'f', // c <---> f
      trans: trans,
      unitSign: unitSign,
      widgetInstance: null,
    }
  },

  watch: {
    oilVolUnit(newVal) {
      localStorage.setItem('oilVolUnit', newVal);
    },
    async oilDays(newVal) {
      localStorage.setItem('oilDays', newVal);
      await this.getOilWidget(); // 기간 변경 시 그래프 재조회
    },
    tankVolUnit(newVal) {
      localStorage.setItem('tankVolUnit', newVal);
    },
    'tankStateWatch': {
      handler: function(newVal) {
        const tank = this.tanks[newVal.tid];
        // console.log("=============> tanksStateWatch------------->", newVal, oldVal, tank);
        if(tank.display) speech(`${tank.name} 탱크, ${newVal.message} `);
      },
      deep: true
    }
  },

  async created(){
    console.log("------------------------- Dashboard created--------------------- ");


    try{
      // await setTanks();
      // await setAreas();

      // this.oilColors = this.$store.state.codeMaps['OIL_COLOR'];
      // this.oilCodeMap = this.$store.state.codeMaps['OIL_CODE'];
      // this.areaCodes = this.$store.state.area['codes'];
      // this.tanks = this.$store.state.tanks['codes'];
      await sleep(2000);

      this.oilColors = this.$store.state.codeMaps['OIL_COLOR'];
      this.oilCodeMap = this.$store.state.codeMaps['OIL_CODE'];
      this.areaCodes = this.$store.state.area['codes'];
      this.tanks =  this.$store.state.tanks['codes'];

      // console.log("--- oilColors --->", this.oilColors );
      const tids = Object.keys(this.tanks)
      // console.log("--- tank ids --->", tids );
      for( const tid of tids ){
        this.volumes[tid] = { dt: null, max: 0, real: 0, ovm: 0, ovc: 0, wv: 0, tvp: 0, avgTm: 0};
        this.tankState[tid] = {
          text:'미확인',
          variant: 'dark',
          pstsVariant: 'dark',
          iosts: '',
          tsts: {
            code:'0000',
            message:'',
            updatedAt: null
          },
          psts: {
            code:'0000',
            message:'',
            updatedAt: null
          }
        };
        this.events[tid] = { events: [], dt: new Date() };
        // this.tankChartKey[tid] = random(0,10000);
      }
      // console.log( 'areaCodes --->', this.areaCodes );
      await this.getOilWidget();
      /*
      console.log( 'this.$watch ------------->', this.$watch );
      Object.keys(this.tankState).map(k=>{
        console.log( 'register watch --- key=', k )
        // this.$watch( ()=>this.tankState[k].tsts, this.watchState, {deep: true});
        this.$watch(
          () => JSON.stringify(this.tankState[k].tsts),
          (newValue, oldValue) => {
            console.log( '%%%%%%%%%%%% watch---->', newValue, oldValue)
          }
        );
      });*/
      // console.log( 'this.$watch ------------->', this.$watch );

      await sleep(1000);
      this.isReady = true;



      this.socket = this.$store.state.socket;

      if( this.socket ) {
        this.socket.removeListener('tank-sts', this.tankStateHandler);
        this.socket.removeListener('event', this.eventAlarmHandler);
        this.socket.removeListener('inventory', this.inventoryHandler);
        this.socket.removeListener('disconnect');
        this.socket.removeListener('connect');
      }

      await sleep(1000);

      console.warn("[MONITOR] ############ register atgDataHandler #########");
      // this.socket.removeAllListeners('tank-sts');
      // this.socket.removeAllListeners('event');
      this.socket.on('tank-sts', this.tankStateHandler);
      this.socket.on('event', this.eventAlarmHandler);
      this.socket.on('inventory', this.inventoryHandler);

      this.socket.on('disconnect', ()=>{
        speech('ATG 서버와 통신이 유실 되었습니다.');
        // modalWarn(this.$bvModal, 'ATG 서버와 통신이 유실 되었습니다.');
        this.$store.state.serverConnected = false;
        // alert("[WARN] ATG 서버와 통신이 유실되었습니다. 모니터링을 종료합니다.")
        // window.close();
      });

      this.socket.on('connect', ()=>{
        speech('ATG 서버와 통신이 연결 되었습니다.');
        this.$store.state.serverConnected = true;
        //modalSuccess(this.$bvModal, 'ATG 서버와 통신이 연결 되었습니다.');
      });

      await sleep(1000);

      console.warn( "[MONITOR] ############ socket object ------> is connecting? ", this.socket.connected );

      await this.getTankChart();

    }catch(err){
      console.error(err);
    }

  },
  async mounted(){
    console.log( '[Dashboard] mounted --------------------');


  },

  methods: {
    // 패킷 상태 코드 → 헤더 배지 아이콘 이름
    pstsIcon(code){
      return PacketStsIconMap[code] || PacketStsIconMap[''];
    },

    watchState(oldVal, newVal){
      console.log( '!!!!!!!!!!!! sts --->', oldVal, newVal );
    },
    progressVariant(v){
      if(!v) return 'dark';

      if(v<40) return 'warning';
      else if(v > 90) return 'danger';
      else return 'info';
    },

    gotoMonitor(arCode, tankId='') {

      let tid = tankId? tankId: '';
      let mode = tid? 'tank':'area';

      let query = `mode=${mode}&arCode=${arCode}&tid=${tid}`;
      // console.log( '%%%%%%%%%%%%%%%% gotoMonitor ------------- store.state.user ---->', this.$store.state.user );
      let width=930;
      let winName = arCode;
      if(tid) {
        width = 514;
        winName = tid;
      }

      let route = this.$router.resolve({ path: `/monitoring?${query}`});
      const features = `left=0,top=0,width=${width},height=545,status=no,titlebar=no,location=no,menubar=no,toolbar=no`
      const newWin = window.open(route.href, `monitor_${winName}`, features );
      newWin.storedUser = localStorage.user;
      // console.log(  'stored user --->', newWin.storedUser );

    },

    /** 지역 카드(대시보드 그래프)를 별도 팝업 창으로 띄운다 (경보판 팝업과 같은 방식) */
    openAreaPopup(arCode){
      const route = this.$router.resolve({ path: `/dashboard-area?arCode=${arCode}` });
      const features = 'left=0,top=0,width=1900,height=980,status=no,titlebar=no,location=no,menubar=no,toolbar=no,scrollbars=yes';
      const newWin = window.open(route.href, `dashboard_${arCode}`, features);
      if(!newWin){
        this.toastWarn('팝업이 차단되었습니다. 브라우저 팝업 허용 후 다시 시도하세요.');
        return;
      }
      // 팝업 창은 별도 앱 인스턴스라 인증정보를 넘겨준다
      newWin.storedUser = localStorage.user;
    },

    tankStateHandler(data){
      // console.log('tankStateHandler--------------', data );
      const {tid} = data;
      const tState = this.tankState[tid];
      // console.log( tnm, tid,'--- tank state --->',tState );
      if(!tState){
        // console.warn( `[${tid}] ${tnm} --- TankState not found skip process, check area of tank` );
        return false;
      }

      let volume = data.payload.volume;
      this.volumes[tid] = volume;
      // console.log( '############## volumes by tid ---------->', tid, this.volumes[tid] );

      const {sts} = data;
      const {psts} = data.payload;

      // console.log( tnm, tid,'--- tank sts --->',sts );




      tState.tsts = sts;
      tState.psts = psts;
      tState.sts = sts.io;

      tState.text = IoStsMap[sts.io];

      switch (sts.io) {
        case 'I':
          tState.variant = 'danger';
          break;
        case 'O':
          tState.variant = 'info';
          break;
        case 'N':
          tState.variant = 'success';
          break;
        case 'R':
          tState.variant = 'danger';
          break;
        case 'D':
          tState.variant = 'warning';
          break;
        default:
          tState.text = '미확인';
          tState.variant = 'secondary';
          break;
      }

      switch(psts.code){
        case 'PKT_LST':
          tState.pstsVariant = 'danger';
          break;
        case 'PKT_DN':
          tState.pstsVariant = 'warning';
          break;
        case 'NO_PKT':
          tState.pstsVariant = 'dark';
          break;
        case 'READY':
          tState.pstsVariant = 'info';
          break;
        case '0000':
          tState.pstsVariant = 'success';
          break
        default:
          tState.pstsVariant = 'dark';
          break;
      }


      if(sts.code!=='0000'){
        tState.text = sts.code;
        tState.variant = 'danger';

        if( sts.code.indexOf('ER_') > -1 ) {
          this.tankStateWatch.tid = tid;
          this.tankStateWatch.code = sts.code;
          this.tankStateWatch.message = sts.message;
        }
      }


      // this.tankStateWatch = tsts;


      // console.log( '############## tankState by tid ---------->', tid, this.tankState[tid] );

      this.progressKey = random(0,10000);

    },

    eventAlarmHandler(data){

      let tid = data.tid;
      let events = data.payload;
      this.events[tid] = {data: events, dt: data.dt };

      let instance = null;
      let iNm = `evt-${tid}`
      if( Array.isArray( this.$refs[iNm]) ) instance = this.$refs[iNm][0];
      else instance = this.$refs[iNm];

      instance?.setEvents( this.events[tid] );

      // console.log('************ eventAlarmHandler-------------', this.events[tid] );

    },

    async inventoryHandler(data){
      // console.log('^^^^^^^^^^^^ inventoryHandler ^^^^^^^^^^^^^^' );
      let tid = data.tid;
      await this.getTankChart(tid);

    },

    /**
     * 상단 유종별 그래프 데이터 (선택 기간을 일단위로 집계)
     * @returns {Promise<void>}
     */
    async getOilWidget(){

      try{
        this.isOilReady = false; // 새로고침 버튼 중복 클릭 방지

        const r = await apiCall('get', `/api/graph/widget-oil/${this.oilDays * 24}?unit=day`);
        if(r.code===200){
          this.oilStore = r.result.oilStore;
          this.oilHist = r.result.oilHist;
          this.oilCodes = Object.keys(this.oilStore);
        }

        // console.log( 'oilCodes ------------>', this.oilCodes );
        // console.log( 'oilHist ------------->', this.oilHist );


      }catch(err){
        console.error(err);
        await this.toastError(err);
      }finally{
        this.isOilReady = true;
      }
    },

    /**
     * 탱크별 데이터
     * @param tid
     * @returns {Promise<void>}
     */
    async getTankChart(tid=''){
      let instance;
      try{
        let query='';
        if(tid) query= `tid=`+tid;
        const r = await apiCall('get', `/api/graph/tank/24?${query}`);
        if(r.code===200){
          if(tid && r.result.tankHist[tid] ) {
            const nm = 'chart-'+tid;
            // this.tankChartKey[tid]++;
            instance = Array.isArray(this.$refs[nm])?this.$refs[nm][0]:this.$refs[nm];
            instance?.setChartData( r.result.tankHist[tid] );
          }else{

            for( const tid in r.result.tankHist){
              const nm = 'chart-'+tid;
              instance = Array.isArray(this.$refs[nm])?this.$refs[nm][0]:this.$refs[nm];
              instance?.setChartData( r.result.tankHist[tid] );
            }
          }

          // console.log( 'tankHist --------->', this.tankHist );
        }

      }catch(err){
        console.error(err);
        await this.toastError(err);
      }finally{
        instance = null;
      }
    }
  },

  beforeDestroy(){
    // console.log("Dashboard destroy---------------------->")
    // using "removeListener" here, but this should be whatever $socket provides
    // for removing listeners
    if(this.socket) {
      this.socket.removeListener('tank-sts', this.tankStateHandler);
      this.socket.removeListener('event', this.eventAlarmHandler);
      this.socket.removeListener('inventory', this.inventoryHandler);
      this.socket.removeListener('disconnect');
      this.socket.removeListener('connect');
    }
  },



}
</script>
